import {Component, OnInit, Renderer2} from '@angular/core';
import {ApiService} from './api.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Observable, interval} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {BodyFieldToSave} from './bodyFieldToSave';
import {DatePipe} from '@angular/common';
import {$locationShim, $locationShimProvider} from '@angular/common/upgrade';
import {TranslateService} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  dashColor: string;
  backColor: string;
  squareColor: string;
  cardColor: string;
  sub: any;
  first = true;
  todayDate = new Date();
  OAUTHCODE: string;
  code: string;

  constructor(public translate: TranslateService, private route: ActivatedRoute, private router: Router, public apiService: ApiService,
              private renderer: Renderer2, private snackBar: MatSnackBar, private datePipe: DatePipe, private activatedRoute: ActivatedRoute, private http: HttpClient) {
    /*this.activatedRoute.queryParams.subscribe(params => {
        let code = params['code'];

        // console.log(code);// OUTPUT 1534
    });*/
    /*window.console.log = () => {
    };*/
    this.apiService.getStates().subscribe(states => {
      this.apiService.allStates = states;
    });
    /*this.http.get('assets/Assets.json').subscribe(data => {
      let jsonData: any;
      jsonData = data;
      this.apiService.dashColor = jsonData.DASH;
      this.apiService.backColor = jsonData.BACK;
      this.apiService.squareColor = jsonData.SQUARE;
      this.apiService.cardColor = jsonData.CARD;
    });*/
    this.apiService.getTheme().subscribe(data => {
      this.apiService.getUserInfo().subscribe(info => {
        this.apiService.userInfo = info;
        if (this.apiService.isLoggedIn()){
          this.apiService.getBetUserSetting().subscribe(currentSetting => {
            if (currentSetting.error){
              if (currentSetting.error === 'No user settings'){
                this.apiService.setBetUserSetting(data[0].id).subscribe(us => {
                  this.dashColor = data[0].dash_color;
                  this.backColor = data[0].back_color;
                  this.squareColor = data[0].square_color;
                  this.cardColor = data[0].card_color;
                  this.apiService.dashColor = this.dashColor;
                  this.apiService.backColor = this.backColor;
                  this.apiService.squareColor = this.squareColor;
                  this.apiService.cardColor = this.cardColor;
                  this.renderer.setStyle(document.body, 'background', this.backColor);
                });
              }else{
                this.apiService.updateBetUserSetting(data[0].id).subscribe(us => {
                  this.dashColor = data[0].dash_color;
                  this.backColor = data[0].back_color;
                  this.squareColor = data[0].square_color;
                  this.cardColor = data[0].card_color;
                  this.apiService.dashColor = this.dashColor;
                  this.apiService.backColor = this.backColor;
                  this.apiService.squareColor = this.squareColor;
                  this.apiService.cardColor = this.cardColor;
                  this.renderer.setStyle(document.body, 'background', this.backColor);
                });
              }
            }else{
              this.dashColor = currentSetting[0].dash_color;
              this.backColor = currentSetting[0].back_color;
              this.squareColor = currentSetting[0].square_color;
              this.cardColor = currentSetting[0].card_color;
              this.apiService.dashColor = this.dashColor;
              this.apiService.backColor = this.backColor;
              this.apiService.squareColor = this.squareColor;
              this.apiService.cardColor = this.cardColor;
              this.renderer.setStyle(document.body, 'background', this.backColor);
            }
          });
        }else{
          this.dashColor = data[0].dash_color;
          this.backColor = data[0].back_color;
          this.squareColor = data[0].square_color;
          this.cardColor = data[0].card_color;
          this.apiService.dashColor = this.dashColor;
          this.apiService.backColor = this.backColor;
          this.apiService.squareColor = this.squareColor;
          this.apiService.cardColor = this.cardColor;
          this.renderer.setStyle(document.body, 'background', this.backColor);
        }
      });

    });
    this.sub = interval(2000)
      .subscribe((val) => {
        this.todayDate = new Date();
        // // console.log(localStorage.getItem('expires'));
        let expired = new Date(localStorage.getItem('expires'));
        if (this.todayDate > expired) {
          this.router.navigate(['login', {expired: true}]);
          this.apiService.setLoggedOut();
        }
      });
    if (this.apiService.isLoggedIn()) {
      this.sub = interval(10000)
        .subscribe((val) => {
          this.apiService.postTasksId().subscribe(value => {
            if (this.first === true) {
              this.apiService.taskNumber = value.data.length;
              this.first = false;
            }
            let columnIdIndex;
            value.columns.forEach((col, index) => {
              if (col.id === 'ID') {
                columnIdIndex = index;
              }
            });
            // // console.log('Task number ->' + this.apiService.taskNumber);
            // // console.log('Risultato chiamata -> ' + value.data.length);
            if (value.data.length > 0) {
              if (value.data.length > this.apiService.taskNumber.length) {
                // // console.log('è entrato');
                let newTask;
                value.data.forEach(vd => {
                  let found = false;

                  this.apiService.taskNumber.forEach(tn => {
                    if (tn === vd) {
                      found = true;
                    }
                  });
                  if (!found) {
                    newTask = vd;
                  }
                });
                this.snackBar.open(this.translate.instant('advices.newTask'), this.translate.instant('advices.goToTask') + newTask[columnIdIndex], {
                  duration: 4500,
                  horizontalPosition: 'end',
                  verticalPosition: 'bottom',
                  panelClass: ['mat-toolbar', 'custom-info-bg']
                }).onAction()
                  .subscribe(() => this.router.navigate
                  (['dashboard/dashnav/dettaglitask', {id: newTask[columnIdIndex], path: 'defaulthome'}], {relativeTo: this.route}));
                this.apiService.taskNumber = value.data;
              } else {
                this.apiService.taskNumber = value.data;
              }
            } else {
              // // console.log(value.data.length);
              this.apiService.taskNumber = value.data;
            }
          });
        });
    }
  }

  TransformDataFormatToShow(Data: string): string {
    return this.datePipe.transform(Data, 'dd/MM/yyyy h:mm:ss', '', 'en-GB');
  }

  ngOnInit(): void {
    if (localStorage.getItem('waitforcodedocu') === 'true') {
      this.activatedRoute.queryParams.subscribe(params => {
        this.code = params['code'];
        if (this.code !== undefined) {
          this.apiService.OAUTHCODE = this.code;
          localStorage.setItem('waitforcodedocu', 'false');
          if (localStorage.getItem('loggedIn')) {
            this.router.navigate(['dashboard']);
          } else {
            this.router.navigate(['login']);
          }
        }
      });
    } else if (localStorage.getItem('waitforcodegoogle') === 'true') {
      this.activatedRoute.queryParams.subscribe(params => {
        this.code = params.code;
        if (this.code !== undefined) {
          this.apiService.AUTHCODE = this.code;
          localStorage.setItem('waitforcodegoogle', 'false');
          if (localStorage.getItem('loggedIn')) {
            this.router.navigate(['dashboard']);
          } else {
            this.router.navigate(['login']);
          }
        }
      });

      /*if (localStorage.getItem('loggedIn')) {
          this.router.navigate(['dashboard']);
      } else {
          this.router.navigate(['login']);
      }*/
    } else {
      if (localStorage.getItem('loggedIn')) {
        this.router.navigate(['dashboard']);
      } else {
        this.router.navigate(['login']);
      }
    }
  }
}
